<template>
    <div>
        <KDialog v-show="showPopup" :title="'Assign User'" @close="cancel">
            <div class="k-mb-1">
                <p>Select the user to assign the encounter to</p>
                <KDropDownList :data-items="workPoolUsers"
                               :text-field="'text'"
                               :data-item-key="'actionLink'"
                               :value="selectedWorkPoolUser"
                               :popup-settings="{ className: 'dropDownWidthFix'}"
                               @change="onUserSelectionChange">
                </KDropDownList>
            </div>
            <KDialogActionsbar layout="end">
                <KButton :theme-color="'primary'"
                         :disabled="!selectedWorkPoolUser"
                         @click='confirmChange'>Confirm</KButton>
                <KButton :theme-color="'info'" :fill-mode="'outline'" @click='cancel'>Cancel</KButton>
            </KDialogActionsbar>
        </KDialog>
    </div>
</template>

<script setup>
    import { defineProps, defineEmits, ref, watch } from 'vue';
    import { Dialog as KDialog, DialogActionsBar as KDialogActionsbar } from '@progress/kendo-vue-dialogs';
    import { Button as KButton } from '@progress/kendo-vue-buttons';
    import { DropDownList as KDropDownList } from "@progress/kendo-vue-dropdowns";
    import logger from "./../../modules/logger";
    import { fetchAPI } from '../../modules/fetchAPI';

    const props = defineProps(['encounterId', 'currentWorkpoolId', 'showDialog']);
    const emit = defineEmits(['assigned', 'assigncancelled']);

    const workPoolUsers = ref([]);

    const selectedWorkPoolUser = ref(null);

    const showPopup = ref(false);

    watch(() => props.showDialog, (newValue) => { updated(newValue); });

    function updated(newValue) {
        showPopup.value = newValue;

        if (showPopup.value === true) {
            getWorkPoolUsers();
        }
    }

    function getWorkPoolUsers() {
        let request = {
            encounterId: props.encounterId,
            workPoolId: props.currentWorkpoolId
        }

        fetchAPI('api/Encounter/GetWorkPoolUserListForMoveEncounter', request)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (!data) {
                    return;
                }

                workPoolUsers.value = [...data];
                selectedWorkPoolUser.value = data[0];
            })
            .catch(error => logger.error('Error: ' + error))
            .finally(() => {
            });
    }

    function onUserSelectionChange(e) {
        selectedWorkPoolUser.value = e.value;
    }

    function toggleDialog() {
        showPopup.value = !showPopup.value;
    }

    function cancel() {
        toggleDialog();
        emit("assigncancelled");
    }

    function confirmChange() {
        let request = {
            encounterId: props.encounterId,
            workpoolId: props.currentWorkpoolId,
            assignToUserId: selectedWorkPoolUser.value?.actionLink ?? null
        }

        fetchAPI('api/Encounter/AssignUser', request)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                toggleDialog();
                    emit("assigned", { result: data });
            })
            .catch(error => logger.error('Error: ' + error))
            .finally(() => {
            });
    }

</script>